import {useTranslation} from 'react-i18next'
import {Tag} from '@/components/ui/tag'
import type {NivelDistribucion} from '@/hooks/bateria/use-bateria'
import {dominantNivel, NIVEL_TONE, totalPersonas} from '@/lib/bateria'

export function NivelTag({dist}: {dist: NivelDistribucion}) {
  const {t} = useTranslation()
  const nivel = dominantNivel(dist)
  if (!nivel) return <Tag tone="neutral">{t('admin.bateria.nivel.sinDato')}</Tag>
  return <Tag tone={NIVEL_TONE[nivel]}>{t(`admin.bateria.nivel.${nivel}`)}</Tag>
}

/** Con el conteo de personas al lado, para filas sin una columna propia de `n`. */
export function SegmentoResumenTag({dist}: {dist: NivelDistribucion}) {
  const {t} = useTranslation()
  return (
    <span className="flex items-center gap-1.5">
      <NivelTag dist={dist} />
      <span className="font-mono text-[11px] text-muted-foreground">
        {t('admin.bateria.resultados.nPersonas', {count: totalPersonas(dist)})}
      </span>
    </span>
  )
}
